import { useBreakpointValue } from '@chakra-ui/react';
import { FC } from 'react';

import { Carousel } from '@/components/ui/shared/carousel/Carousel';
import { FlippingLectureCard } from '@/components/ui/shared/lecture/FlippingLectureCard/FlippingLectureCard';
import { LectureCardSkeleton } from '@/components/ui/shared/lecture/LectureCard/LectureCardSkeleton/LectureCardSkeleton';
import { useAnalytics } from '@/context/Analytics';
import { ThinLecture } from '@/resources/ThinLecture';

interface ISubjectLecturesDesktopProps {
  items: Array<ThinLecture>;
  isLoadingMore: boolean;
  onLoadMore: () => void;
  isReachingEnd: boolean;
}

export const SubjectLectures: FC<ISubjectLecturesDesktopProps> = ({
  items,
  isLoadingMore,
  onLoadMore,
  isReachingEnd,
}) => {
  const analytics = useAnalytics();
  const cardWidth = useBreakpointValue({ base: 335, md: 389.3 });

  function handleOnClick(lecture: ThinLecture) {
    analytics.track('library_landing_lecture_open', {
      lecture_name: lecture.title,
      lecture_id: lecture.id,
      event_id: lecture.eventId,
    });
  }

  return (
    <Carousel
      mt="32px"
      mb="16px"
      data={items}
      render={(lecture) => {
        return <FlippingLectureCard onClick={() => handleOnClick(lecture)} lecture={lecture} />;
      }}
      widthCard={cardWidth}
      itemLoader={<LectureCardSkeleton h="full" w={cardWidth} />}
      onLoadMore={onLoadMore}
      isLoadingMore={isLoadingMore}
      isReachingEnd={isReachingEnd}
    />
  );
};
